// https://www.npmjs.com/package/ng-bootstrap-icons
// Usage: <bi name="cloud-arrow-up-fill" class="someclass"></bi>
// Get the icon names https://icons.getbootstrap.com/ or see the svg file name in /node-modules/bootstrap-icons/
// Naming: here in this file in CamelCase, in the component html lowercase with dash (-). e.g. CloudArrowUpFill here, in html cloud-arrow-up-fill

import { NgModule } from '@angular/core';

import { BootstrapIconsModule } from 'ng-bootstrap-icons';
import { Alarm, App, Bookmark, CloudArrowUpFill, GearWideConnected } from 'ng-bootstrap-icons/icons';

// Select some icons (use an object, not an array)
const icons = {
  Alarm,
  App,
  Bookmark,
  CloudArrowUpFill,
  GearWideConnected
};

@NgModule({
  imports: [
    BootstrapIconsModule.pick(icons)
  ],
  exports: [
    BootstrapIconsModule
  ]
})
export class IconsModule { }